// Formatting Quill stores as CSS classes must be defined anywhere saved HTML is
// rendered outside an editor, especially in cloned print documents and PDFs.
export const QUILL_RENDERED_CONTENT_CLASS = 'quill-rendered-content';

export const QUILL_PRINT_CONTENT_CSS = `
  .ql-align-left { text-align: left !important; }
  .ql-align-center { text-align: center !important; }
  .ql-align-right { text-align: right !important; }
  .ql-align-justify { text-align: justify !important; }
  .ql-direction-rtl { direction: rtl !important; text-align: inherit; }
  .ql-indent-1 { padding-left: 3em !important; }
  .ql-indent-2 { padding-left: 6em !important; }
  .ql-indent-3 { padding-left: 9em !important; }
  .ql-indent-4 { padding-left: 12em !important; }
  .ql-indent-5 { padding-left: 15em !important; }
  .ql-indent-6 { padding-left: 18em !important; }
  .ql-indent-7 { padding-left: 21em !important; }
  .ql-indent-8 { padding-left: 24em !important; }
  .ql-indent-9 { padding-left: 27em !important; }
  blockquote { border-left: 4px solid #ccc; margin: 5px 0; padding-left: 16px; }
  .ql-code-block-container { background: #23241f; color: #f8f8f2; font-family: monospace; padding: 5px 10px; }
  .ql-ui { display: none !important; }
  .${QUILL_RENDERED_CONTENT_CLASS} {
    box-sizing: border-box !important;
    overflow: visible !important;
  }
  .${QUILL_RENDERED_CONTENT_CLASS} .ql-table-wrapper {
    width: 100% !important;
    max-width: 100% !important;
    overflow: visible !important;
  }
  .${QUILL_RENDERED_CONTENT_CLASS} table,
  .${QUILL_RENDERED_CONTENT_CLASS} table.ql-table-better {
    width: calc(100% - 2px) !important;
    max-width: calc(100% - 2px) !important;
    margin-left: 1px !important;
    margin-right: 1px !important;
    border: 1px solid #555 !important;
    border-collapse: collapse !important;
    border-spacing: 0 !important;
    table-layout: fixed !important;
    box-sizing: border-box !important;
    box-shadow: inset 0 0 0 1px #555 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
  .${QUILL_RENDERED_CONTENT_CLASS} thead { display: table-header-group !important; }
  .${QUILL_RENDERED_CONTENT_CLASS} tbody { display: table-row-group !important; }
  .${QUILL_RENDERED_CONTENT_CLASS} tr {
    break-inside: avoid !important;
    page-break-inside: avoid !important;
  }
  .${QUILL_RENDERED_CONTENT_CLASS} th,
  .${QUILL_RENDERED_CONTENT_CLASS} td,
  .${QUILL_RENDERED_CONTENT_CLASS} table.ql-table-better th,
  .${QUILL_RENDERED_CONTENT_CLASS} table.ql-table-better td {
    min-width: 0 !important;
    border: 1px solid #555 !important;
    box-shadow: inset 0 0 0 1px #555 !important;
    background: #fff !important;
    padding: 4px 6px !important;
    vertical-align: top !important;
    white-space: normal !important;
    overflow-wrap: anywhere !important;
    word-break: break-word !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
  .${QUILL_RENDERED_CONTENT_CLASS} .ql-table-block {
    margin: 0 !important;
    min-height: 1.25em !important;
  }
  .${QUILL_RENDERED_CONTENT_CLASS} .ql-cell-selected,
  .${QUILL_RENDERED_CONTENT_CLASS} .ql-cell-selected-after,
  .${QUILL_RENDERED_CONTENT_CLASS} .ql-cell-focused {
    background: transparent !important;
    outline: none !important;
  }
  .${QUILL_RENDERED_CONTENT_CLASS} .ql-cell-selected::after,
  .${QUILL_RENDERED_CONTENT_CLASS} .ql-cell-selected-after,
  .${QUILL_RENDERED_CONTENT_CLASS} .ql-cell-focused::after {
    content: none !important;
    display: none !important;
  }
`;

export const QUILL_CONTENT_SX = {
  '& .ql-align-left': { textAlign: 'left !important' },
  '& .ql-align-center': { textAlign: 'center !important' },
  '& .ql-align-right': { textAlign: 'right !important' },
  '& .ql-align-justify': { textAlign: 'justify !important' },
  '& .ql-direction-rtl': { direction: 'rtl' },
  '& .ql-indent-1': { paddingLeft: '3em !important' },
  '& .ql-indent-2': { paddingLeft: '6em !important' },
  '& .ql-indent-3': { paddingLeft: '9em !important' },
  '& .ql-indent-4': { paddingLeft: '12em !important' },
  '& .ql-indent-5': { paddingLeft: '15em !important' },
  '& .ql-indent-6': { paddingLeft: '18em !important' },
  '& .ql-indent-7': { paddingLeft: '21em !important' },
  '& .ql-indent-8': { paddingLeft: '24em !important' },
  '& .ql-indent-9': { paddingLeft: '27em !important' },
  '& blockquote': {
    borderLeft: '4px solid #ccc',
    margin: '5px 0',
    paddingLeft: '16px'
  },
  '& .ql-code-block-container': {
    bgcolor: '#23241f',
    color: '#f8f8f2',
    fontFamily: 'monospace',
    padding: '5px 10px'
  },
  '& .ql-ui': { display: 'none !important' }
};
